export default class Filter {
  constructor(app) {
    this.app = app;

    this.accordionHeadElements = [];
    this.filterObservers = [];

    this.init = this.init.bind(this);
    this.events = this.events.bind(this);
    this.destroy = this.destroy.bind(this);

    this.setInitialAccordionState = this.setInitialAccordionState.bind(this);
    this.isAccordionExpanded = this.isAccordionExpanded.bind(this);
    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.expandAccordion = this.expandAccordion.bind(this);
    this.closeAccordion = this.closeAccordion.bind(this);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.onFilterOptionsChange = this.onFilterOptionsChange.bind(this);

    this.init();
  }

  init() {
    this.openButton = document.querySelector('.js-filters-open');
    this.closeButton = document.querySelector('.js-filters-close');
    this.modal = document.querySelector('.js-filters-modal');
    this.accordionHeadElements = document.querySelectorAll('.js-filter-head');

    for (let i = 0; i < this.accordionHeadElements.length; i += 1) {
      const headElement = this.accordionHeadElements[i];
      const filter = headElement.parentElement;
      this.setInitialAccordionState(filter);
    }

    this.events();
  }

  setInitialAccordionState(filter) {
    if (this.isAccordionExpanded(filter)) {
      this.expandAccordion(filter);
    } else {
      this.closeAccordion(filter);
    }

    const hasOptions = this.checkIfFilterHasOptions(filter);
    this.setFilterVisibility(filter, hasOptions);
  }

  checkIfFilterHasOptions(filter) {
    const facet = filter.querySelector('.facetwp-facet');
    if (!facet) return false;
    if (facet.children.length === 0) return false;
    return true;
  }

  setFilterVisibility(filter, visible) {
    if (!visible) filter.classList.add('--hidden');
    else filter.classList.remove('--hidden');
  }

  events() {
    if (this.openButton) this.openButton.addEventListener('click', this.openModal);
    if (this.closeButton) this.closeButton.addEventListener('click', this.closeModal);

    for (let i = 0; i < this.accordionHeadElements.length; i += 1) {
      const headElement = this.accordionHeadElements[i];
      headElement.addEventListener('click', this.onAccordionClick);

      // Listen to changes in the filter options
      const filter = headElement.parentElement;
      const observer = new MutationObserver(() => {
        this.onFilterOptionsChange(filter);
      });
      this.filterObservers.push(observer);
      const facet = filter.querySelector('.facetwp-facet');
      observer.observe(facet, { childList: true });
    }
  }

  openModal() {
    this.modal.classList.add('--active');
  }

  closeModal() {
    this.modal.classList.remove('--active');
  }

  destroy() {
    if (this.accordionHeadElements) {
      for (let i = 0; i < this.accordionHeadElements.length; i += 1) {
        this.accordionHeadElements[i].removeEventListener('click', this.onAccordionClick);
      }
      this.accordionHeadElements = [];

      this.filterObservers.forEach((observer) => {
        observer.disconnect();
      });
      this.filterObservers = [];
    }
  }

  isAccordionExpanded(filter) {
    return filter.classList.contains('--expanded');
  }

  onAccordionClick(event) {
    const filter = event.currentTarget.parentElement;
    if (this.isAccordionExpanded(filter)) {
      this.closeAccordion(filter);
    } else {
      this.expandAccordion(filter);
    }
  }

  onFilterOptionsChange(filter) {
    const hasOptions = this.checkIfFilterHasOptions(filter);
    this.setFilterVisibility(filter, hasOptions);
  }

  expandAccordion(filter) {
    filter.classList.add('--expanded');
  }

  closeAccordion(filter) {
    filter.classList.remove('--expanded');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/filter.js